import { mapCollection } from '../../utils/collection.utils';
import { parseNumber } from '../../utils/number.utils';
import { ToolSetting } from '../tool-setting';
import { ToolSettingMode } from '../tool-setting-mode';
import { Tool } from '../tool';
import { ToolHolder } from '../tool-holder';
import { ToolStep } from '../tool-step';
import { ToolHolderStep } from '../tool-holder-step';
import { RefrigerationBuilder } from './refrigeration.builder';
import { ZollerFocusBuilder } from './zoller-focus.builder';
import { ZollerModeBuilder } from './zoller-mode.builder';
import { OperationModeBuilder } from './operation-mode.builder';
import { ToolCategoryBuilder } from './tool-category.builder';
import { CamToolSlimBuilder } from './cam-tool-slim.builder';
import { CamToolBuilder } from './cam-tool.builder';
import { ToolHolderRebuildOptionBuilder } from './tool-rebuild-option.builder';

export class ToolBuilder {
  static fromJson(json) {
    return (json)
      ? new Tool(
        json.hash,
        json.name,
        json.erp,
        parseNumber(json.breakCheck),
        RefrigerationBuilder.fromJson(json.refrigeration),
        ToolCategoryBuilder.fromJson(json.toolCategory),
        ToolHolderRebuildOptionBuilder.buildToolRebuildOptionFromJson(json.toolRebuildOption),
        parseNumber(json.stockNumber),
        parseNumber(json.toStoreCounter),
        parseNumber(json.inUseCounter),
        parseNumber(json.toRebuildCounter),
        parseNumber(json.toValidateCounter),
        parseNumber(json.toErpCounter),
        ToolBuilder.buildSettingModesFromList(json.toolSettingModes),
        ToolBuilder.buildStepsFromList(json.toolSteps),
        json.refrigerationName,
        json.toolCategoryName,
        CamToolSlimBuilder.fromList(json.camTools),
        ToolHolderRebuildOptionBuilder.buildToolRebuildOptionsFromList(json.toolRebuildOptions),
        json.probeMovement
      )
      : null;
  }

  static fromList(list) {
    return mapCollection(ToolBuilder.fromJson, list);
  }

  static buildToolHolderFromJson(json) {
    return (json)
      ? new ToolHolder(
        json.hash,
        json.name,
        json.erp,
        parseNumber(json.stockNumber),
        ToolBuilder.buildHolderStepsFromList(json.toolHolderSteps),
        CamToolBuilder.buildCamToolHolderFromList(json.camToolHolders),
        ToolHolderRebuildOptionBuilder.buildToolHolderRebuildOptionsFromList(json.toolHolderRebuildOptions)
      )
      : null;
  }

  static buildToolHolderFromList(list) {
    return mapCollection(ToolBuilder.buildToolHolderFromJson, list);
  }

  static buildSettingsFromJson(json) {
    return (json)
      ? new ToolSetting(
        json.toolHash,
        json.refrigerationHash,
        json.breakCheck,
        ToolBuilder.buildSettingModesFromList(json.modes)
      )
      : null;
  }

  static buildSettingsFromList(list) {
    return mapCollection(ToolBuilder.buildSettingsFromJson, list);
  }

  static buildSettingModesFromJson(json) {
    return (json)
      ? new ToolSettingMode(
        json.hash,
        OperationModeBuilder.fromJson(json.mode),
        json.modeName,
        parseNumber(json.vibration),
        parseNumber(json.power)
      )
      : null;
  }

  static buildSettingModesFromList(list) {
    return mapCollection(ToolBuilder.buildSettingModesFromJson, list);
  }

  static buildStepsFromJson(json) {
    return (json)
      ? new ToolStep(
        json.hash,
        json.step,
        json.ces,
        parseNumber(json.longitude),
        ZollerFocusBuilder.fromJson(json.zollerFocus),
        ZollerModeBuilder.fromJson(json.zollerMode),
        parseNumber(json.rangeWidth),
        parseNumber(json.rangeHeight),
        parseNumber(json.zRefMode),
        parseNumber(json.zUpperTol),
        parseNumber(json.zLowerTol),
        parseNumber(json.x),
        parseNumber(json.xRefMode),
        parseNumber(json.xUpperTol),
        parseNumber(json.xLowerTol),
        parseNumber(json.radius),
        parseNumber(json.radiusUpperTol),
        parseNumber(json.radiusLowerTol),
        parseNumber(json.angle),
        parseNumber(json.angleUpperTol),
        parseNumber(json.angleLowerTol),
        json.searchRunZ,
        json.searchRunX,
        ZollerFocusBuilder.fromJson(json.zollerFocus).name,
        ZollerModeBuilder.fromJson(json.zollerMode).name
      )
      : null;
  }

  static buildStepsFromList(list) {
    return mapCollection(ToolBuilder.buildStepsFromJson, list);
  }

  static buildHolderStepsFromJson(json) {
    return (json)
      ? new ToolHolderStep(
        json.hash,
        json.step,
        json.ces,
        ZollerFocusBuilder.fromJson(json.zollerFocus),
        ZollerModeBuilder.fromJson(json.zollerMode),
        parseNumber(json.rangeWidth),
        parseNumber(json.rangeHeight),
        parseNumber(json.longitude),
        parseNumber(json.zUpperTol),
        parseNumber(json.zLowerTol),
        parseNumber(json.x),
        parseNumber(json.xUpperTol),
        parseNumber(json.xLowerTol),
        json.searchRunZ,
        json.searchRunX
      )
      : null;
  }

  static buildHolderStepsFromList(list) {
    return mapCollection(ToolBuilder.buildHolderStepsFromJson, list);
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/tool.builder.ts